<template>
  <div class="triangle-container">
    <!-- 横线：从左到点 -->
    <div
        class="line-horizontal"
        :style="{
        width: pointX + 'px',
        top: pointY + 'px'
      }"
    ></div>

    <!-- 竖线：从底到点 -->
    <div
        class="line-vertical"
        :style="{
        height: height - pointY + 'px',
        left: pointX + 'px',
        top: pointY + 'px'
      }"
    ></div>

    <!-- 点 -->
    <div
        class="point"
        :style="{
        left: pointX + 'px',
        top: pointY + 'px'
      }"
    ></div>
  </div>
</template>

<script>
export default {
  name: "TriangleChart",

  props: {
    x: {
      type: Number,
      default: 0.5
    },
    y: {
      type: Number,
      default: 0.5
    }
  },

  computed: {
    width() {
      return 240
    },

    height() {
      return 172
    },

    pointX() {
      return this.width * this.x
    },

    // 坐标系转换（左下为原点）
    pointY() {
      return this.height * (1 - this.y)
    }
  }
}
</script>

<style scoped>
.triangle-container {
  width: 240px;
  height: 172px;
  position: relative;
  background: url(../assets/image/triangle.png) no-repeat center center;
  background-size: 100% 100%;
}

/* 横虚线 */
.line-horizontal {
  position: absolute;
  border-top: 1px dashed #999;
  transform: translateY(-50%);
}

/* 竖虚线 */
.line-vertical {
  position: absolute;
  border-left: 1px dashed #999;
  transform: translateX(-50%);
}

/* 点 */
.point {
  position: absolute;
  width: 10px;
  height: 10px;
  background: #17C0FF;
  border-radius: 50%;
  border-color: #fff;
  border-width: 2px;
  transform: translate(-50%, -50%);
}
</style>
